<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Bulk Report Card</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
             @click="handleBackButton"
          >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-chevron-left" />
                    </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="position-relative" id="FinalBulkexamResult" style="font-size:13px">
      <a-spin :spinning="loading">
      <div
        class="content"
        v-for="(allData, index) in this.data"
        :key="index"
        style="height:778.5px"
      >
        <neo-print-wrapper title="Exam Report">
          <a-spin :spinning="loading">
            <div class="row" style="font-size:15px">
              <!--          student Details -->
             <div class="col-12">
               <b style="margin-bottom:3px">
                 {{ allData.enrollment.student.first_name }}
                 {{ allData.enrollment.student.last_name }}
               </b>
               <p class="mb-2">
                 Student code:
                 <span class="font-weight-bold">{{
                     allData.enrollment.student_code
                   }}</span>
                 | Class:
                 <span class="font-weight-bold">
                                       {{ getClassName(class_Id) }}
                   </span>
                 | Section:
                 <span class="font-weight-bold">
                   {{ getSectionName(section_Id) }}
                   </span>
                 | Roll No:
                 <span class="font-weight-bold">{{
                     allData.enrollment.roll_no
                   }}</span>
               </p>
             </div>
            </div>
            <!-- Report card format -->
            <div class="row">
              <!-- Class(1-above) -->
              <div class="col-12" v-if="reportCardFormat === 0">
                <vue-custom-scrollbar class="scroll-area">
                  <!-- trail -->
                  <table
                    class="table table-sm table-sm-responsive table-bordered "
                    style="font-size:13px" id="markTable"
                  >
                    <!-- top -->
                    <tr>
                      <th></th>
                      <th :colspan="4" style="text-align: center">
                        X-Periodic Tests + Internal Assessment <br />
                        Marks Secured
                      </th>
                      <th style="text-align: center">
                        Y-1st & 2nd Term Test <br />
                        Marks Secured
                      </th>
                      <th></th>
                    </tr>
                    <!--  2nd row subject and Exam column-->
                    <!-- if length = 5 -->
                    <tr v-if="allData.class_section_exams.length === 5">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">1st Term test</th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">2nd P/T</th>
                      <th class="text-center" style="width:14.28%">1st Term Test</th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- PASS MARK & FULL MARK -->
                    <!-- if length = 5 -->
                    <tr v-if="allData.class_section_exams.length === 5">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:40 <br />
                        P.M:14
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:20 <br />
                        P.M:7
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- SUBJECT & MARK-->
                    <!-- if length=5 -->
                    <tr v-if="allData.class_section_exams.length === 5">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- 0 mark -->
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- SCORE-->
                    <!-- if length=5 -->
                    <tr v-if="allData.class_section_exams.length === 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result Pc -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ...0.. -->
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- PC-->
                    <!-- if length=5 -->
                    <tr v-if="allData.class_section_exams.length == 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- final result Pc -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- RANK/DIV-->
                    <!-- if length=5 -->
                    <tr v-if="allData.class_section_exams.length == 5">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>
                  <!-- TEACHERS REMARK -->
                  <table class="table table-sm table-sm-responsive" style="font-size:11px;margin:0px">
                    <!-- Remarks -->
                    <tr>
                      <th colspan="4">
                        <span style="font-size:11px"> Teachers Remark </span>
                      </th>
                      <!-- ...... data....... -->
                    </tr>
                    <!-- if length = 5 -->
                    <tr v-if="allData.class_section_exams.length == 5">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th
                        style="width: 16%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th style="width: 16%;font-size:11px">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">1st T/T :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd P/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">1st-T/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                  </table>
                  <table class="table table-sm table-sm-responsive" style="font-size:11px;margin-top:0px">
                    <!-- Top Exam row -->
                    <tr>
                      <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Teacher's signature</span></th>
                      <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Parent's signature</span></th>
                      <th style="width:33%;text-align:center"><span style="font-size:11px">
                          Principal</span></th>
                    </tr>
                  </table>
                  <b style="font-size: 11px">
                    N.B : Marks of final T/T is 100/2 = 50, so that we can
                    calculate (X+Y) /2 as per board norm.</b>
                </vue-custom-scrollbar>
              </div>
              <!-- Pre-Kg -->
              <div class="col-12" v-else>
                <vue-custom-scrollbar class="scroll-area">
                  <!-- trail -->
                  <table
                    class="table table-sm table-sm-responsive table-bordered "
                    style="font-size:13px" id="markTable2"
                  >
                    <!-- top -->
                    <tr>
                      <th></th>
                      <th :colspan="3" style="text-align: center">
                        X-Periodic Tests + Internal Assessment <br />
                        Marks Secured
                      </th>
                      <th style="text-align: center">
                        Y-1st & 2nd Term Test <br />
                        Marks Secured
                      </th>
                      <th></th>
                    </tr>
                    <!--  2nd row subject and Exam column-->
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">Int. Assess</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">1st Term test</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th class="text-center" style="width:14.28%">SUBJECT</th>
                      <th
                        class="text-center"
                        v-for="(data, index) in allData.class_section_exams"
                        :key="index"
                        style="width:14.28%"
                      >
                        {{ data.exam.name }}
                      </th>
                      <th class="text-center" style="width:14.28%">2nd P/T</th>
                      <th class="text-center" style="width:14.28%">1st Term Test</th>
                      <th class="text-center" style="width:14.28%">2nd Term Test</th>
                      <th class="text-center" style="width:14.28%">
                        Final Result <br />
                        (X+Y)/2 <br />
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- PASS MARK & FULL MARK -->
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col"></th>
                      <th v-for="(data, index) in allData.class_section_exams" :key="index">
                        F.M:{{getFullMark(data)}} <br>
                        P.M:{{getPassMark(data)}}
                      </th>
                      <th>
                        F.M:40 <br />
                        P.M:14
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th>
                        F.M:50 <br />
                        P.M:17
                      </th>
                      <th></th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- SUBJECT & MARK-->
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <!-- 0 mark -->
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">
                            {{ getSubject(subjectList.subject_id) }}
                          </div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examSubject, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            <span
                              :class="
                                getMarksColor(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              "
                            >
                              {{
                                getMarks(
                                  data.student_exam_marks,
                                  examSubject.subject_id
                                )
                              }}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(subjectList, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            NA
                          </div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th scope="col">
                        <div
                          class="Row"
                          style="margin:auto"
                          v-for="(subjectList, index) in allData.student_final_exam_marks"
                          :key="index"
                        >
                          <div class="Column">NA</div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div
                            class="Row"
                            style="margin:auto"
                            v-for="(examMarks, index) in allData.student_final_exam_marks"
                            :key="index"
                          >
                            {{getFinalResultMarks(examMarks)}}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- SCORE-->
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length === 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length === 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length === 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length === 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Score</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamScore(data.student_declared_marks)
                            }}/{{
                              getExamTotalScore(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result mark score -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.total_mark_score
                            }}/{{
                              data.total_exam_full_mark
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- PC-->
                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <!-- final result Pc -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">PC</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamPc(data.student_declared_marks)
                            }}%
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Pc-->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              data.mark_percentage
                            }}%
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!---------------------------------------------------------------------------------------------->
                    <!-- RANK/DIV-->

                    <!-- if length=4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <!-- if length=1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th scope="col">
                        <div class="Row" style="margin:auto">
                          <div class="Column">Rank/Div</div>
                        </div>
                      </th>
                      <!-- marks -->
                      <th v-for="(data, indexx) in allData.class_section_exams" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getExamRankDiv(data.student_declared_marks)
                            }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- ..0... -->
                      <th>
                        <div class="column">
                          <div class="Row" style="margin:auto">NA</div>
                        </div>
                      </th>
                      <!-- final result Rank -->
                      <th v-for="(data, indexx) in allData.student_final_declared_marks" :key="indexx">
                        <div class="column">
                          <div class="Row" style="margin:auto">
                            {{
                              getFinalExamRankDiv(data)
                            }}
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>
                  <!-- TEACHERS REMARK -->
                  <table class="table table-sm table-sm-responsive table-bordered" style="font-size:12px;margin:0px">
                    <!-- Remarks -->
                    <tr>
                      <th colspan="4">
                        <span style="font-size:11px"> Teachers Remark </span>
                      </th>
                      <!-- ...... data....... -->
                    </tr>
                    <!-- if length = 4 -->
                    <tr v-if="allData.class_section_exams.length == 4">
                      <th
                        style="width: 16%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 3 -->
                    <tr v-if="allData.class_section_exams.length == 3">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th style="width: 16%;font-size:11px">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 2 -->
                    <tr v-if="allData.class_section_exams.length == 2">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">1st T/T :......................</span>
                      </th>
                      <th style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                    <!-- if length = 1 -->
                    <tr v-if="allData.class_section_exams.length == 1">
                      <th
                        style="width: 14.28%"
                        v-for="data in allData.class_section_exams"
                        :key="data.exam_id"
                      >
                        <span style="font-size:11px">{{ data.exam.name }} :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd P/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">1st-T/T :......................</span>
                      </th>
                      <th class="text-center" style="width: 16%">
                        <span style="font-size:11px">2nd T/T :......................</span>
                      </th>
                    </tr>
                  </table>
                  <table class="table table-sm table-sm-responsive" style="font-size:12px;margin-top:0px">
                    <!-- Top Exam row -->
                    <tr>
                      <th style="width:50%">Teacher's signature</th>
                      <th style="width:50%">Principal</th>
                    </tr>
                  </table>
                </vue-custom-scrollbar>
              </div>
            </div>
          </a-spin>
        </neo-print-wrapper>
        <!--        Print button-->
        <div class="position-absolute neo-tr-5 d-print-none">
          <button
            type="button"
            class="btn btn-light btn-sm btn-with-addon"
            @click="print"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-printer" />
            </span>
            Print
          </button>
        </div>
      </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'
export default {
  name: 'FinalBulkReport',
  components: {
    vueCustomScrollbar,
    NeoPrintWrapper,
  },
  mounted: function() {
    this.getClassSubjects()
    this.getClassList()
    this.getSectionList()
    this.getFinalExamResult()
  },
  computed: {
    class_Id: function () {
      return this.$route.params.classId
    },
    section_Id: function () {
      return this.$route.params.sectionId
    },
    session_Id: function () {
      return this.$route.params.sessionId
    },
    reportCardFormat: function () {
      return this.$route.params.reportformat
    },
  },
  watch: {
    classList: function (value) {
      return value
    },
    class_name: function (value) {
      return value
    },
    sectionList: function (value) {
      return value
    },
  },
  data: function () {
    return {
      data: null,
      classSubjects: null,
      classList: null,
      sectionList: null,
      class_name: null,
      loading: false,
    }
  },
  methods: {
    handleBackButton() {
      this.$router.push({
        name: 'finalResultReport',
        params: {
          classId: this.class_Id,
          className: this.class_name,
          sessionId: this.session_Id,
        },
      })
    },
    getFinalExamResult() {
      this.loading = true
      // api/reports/student/bosem/bulk/final_result?class_id=137&section_id=47&session_id=44
      this.$http
        .get('api/reports/student/bosem/bulk/final_result', {
          params: {
            class_id: this.class_Id,
            section_id: this.section_Id,
            session_id: this.session_Id,
          },
        })
        .then(({ data }) => {
          this.data = data.data
          this.loading = false
        })
    },
    getSubject(id) {
      if (this.classSubjects.length !== 0) {
        const SubjectName = this.classSubjects.filter(obj => obj.id === id)
        if (SubjectName.length !== 0) {
          return SubjectName[0].name
        } else {
          return '--'
        }
      }
    },
    getClassList() {
      this.loading = true
      this.$http
        .get('api/class?session_id=' + this.session_Id)
        .then(({ data }) => {
          this.classList = data.data
          this.loading = false
        })
    },
    getSectionList() {
      this.loading = true
      this.$http
        .get('api/section/class/' + this.class_Id,
          {
            params: {
              session_id: this.session_id,
            },
          })
        .then(({ data }) => {
          this.sectionList = data.data
          this.loading = false
        })
    },
    getClassSubjects() {
      this.loading = true
      this.$http
        .get('/api/subject/class/' + this.class_Id, {
          params: {
            session_id: this.sessionId,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.normal_subjects
          this.loading = false
        })
    },
    getClassName(id) {
      // return this.classList
      if (this.classList.length !== 0) {
        const ClassName = this.classList.filter(obj => obj.id === id)
        this.class_name = ClassName[0].name
        return ClassName[0].name
      } else {
        return 'NA'
      }
    },
    getSectionName(id) {
      // return id
      if (this.sectionList.length !== 0) {
        const SectionName = this.sectionList.filter(obj => obj.id === id)
        return SectionName[0].name
      } else {
        return 'NA'
      }
    },
    getExamRankDiv(examPcData) {
      if (examPcData.length !== 0) {
        if (examPcData[0].is_failed !== 1) {
          if (examPcData[0].rank != null) {
            return examPcData[0].rank
          } else if (examPcData[0].division != null) {
            return examPcData[0].division
          } else if (examPcData[0].division === null && examPcData[0].rank === null) {
            return '--'
          } else {
            return '--'
          }
        } else {
          return 'F' +
            'Failed'
        }
      }
    },
    getFinalExamRankDiv(examPcData) {
      if (examPcData != null) {
        if (examPcData.is_failed !== 1) {
          if (examPcData.class_rank != null) {
            return examPcData.class_rank
          } else if (examPcData.division != null) {
            return examPcData.division
          } else if (examPcData.division === null && examPcData.class_rank === null) {
            return '--'
          } else {
            return '--'
          }
        } else {
          return 'Failed'
        }
      }
    },
    getExamPc(examPcData) {
      if (examPcData.length !== 0) {
        if (examPcData[0].mark_percentage != null) {
          return examPcData[0].mark_percentage
        } else {
          return '--'
        }
      }
    },
    getExamScore(decData) {
      if (decData.length !== 0) {
        if (decData[0].total_mark_score.length !== 0) {
          return decData[0].total_mark_score
        } else {
          return '--'
        }
      }
    },
    getExamTotalScore(decData) {
      if (decData.length !== 0) {
        if (decData[0].total_exam_full_mark.length !== 0) {
          return decData[0].total_exam_full_mark
        } else {
          return '--'
        }
      }
    },
    getFinalResultMarks(marksData) {
      if (marksData != null) {
        if (marksData.exam_mark_score != null) {
          return marksData.exam_mark_score
        } else if (marksData.exam_mark_grade != null) {
          return marksData.exam_mark_grade
        } else if (marksData.exam_mark_grade === null && marksData.exam_mark_score === null) {
          return '--'
        } else {
          return '--'
        }
      }
    },
    getMarks(marksArray, subjeectId) {
      if (marksArray.length !== 0) {
        var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
        if (foundValue.length !== 0) {
          var newObj = Object.assign({}, ...foundValue)
          if (newObj.is_absent === 0) {
          // if exam_mark_score
            if (newObj.exam_mark_score !== null) {
              return newObj.exam_mark_score
            } else if (newObj.exam_mark_grade !== null) {
              return newObj.exam_mark_grade
            } else if (newObj.exam_mark_grade === null && newObj.exam_mark_score === null) {
              const absent = '--'
              return absent
            } else {
              const absent = '--'
              return absent
            }
          } else {
            const absent = 'AB'
            return absent
          }
        } else {
          const noDatafound = '--'
          return noDatafound
        }
      } else {
        return '--'
      }
    },
    getMarksColor(marksArray, subjeectId) {
      if (marksArray.length !== 0) {
        var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
        // const y = find(x ["subject_id", u])
        if (foundValue.length !== 0) {
        // var mapped = foundValue.map(item => ({ [item.exam_mark_score]: item.subject_id }))
          var newObj = Object.assign({}, ...foundValue)
          // console.log(newObj);
          if (newObj.is_absent === 1) {
            return 'text-danger'
          } else {
            if (newObj.is_failed === 1) {
              return 'text-danger'
            } else {
              return 'text-dark'
            }
          }
        } else {
          return 'text-danger'
        }
      } else {
        return 'text-dark'
      }
    },
    getFullMark(markData) {
      if (markData.student_exam_marks != null) {
        var fullmark = null
        fullmark = markData.student_exam_marks.filter(obj => obj.exam_full_mark != null)
        if (fullmark.length !== 0) {
          return fullmark[0].exam_full_mark
        }
      }
    },
    getPassMark(markData) {
      if (markData.student_exam_marks != null) {
        var passmark = null
        passmark = markData.student_exam_marks.filter(obj => obj.exam_pass_mark != null)
        if (passmark.length !== 0) {
          return passmark[0].exam_pass_mark
        }
      }
    },
    // handleBackButton() {
    //   this.$router.push({ name: 'finalResultReport' })
    // },
    print() {
      this.$htmlToPaper('FinalBulkexamResult')
    },
  },
}
</script>
